import { render, staticRenderFns } from "./SitesEditor.vue?vue&type=template&id=4c26b3c1&scoped=true"
import script from "./SitesEditor.vue?vue&type=script&lang=js"
export * from "./SitesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c26b3c1",
  null
  
)

export default component.exports